module.exports = __webpack_public_path__ + "static/img/fei.305aa07.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/fei.png
// module id = DGoG
// module chunks = 1